const STORAGE_KEYS = {
  haveShownDialog: "uq.organizationSwitch.haveShownDialog",
  organizationSwitch: "uq.organizationSwitch",
};

export default STORAGE_KEYS;
